/* POST_KIOSK × PRODUCT journey — thin shell (GC-P1-05). */

import { JourneyShell } from './JourneyShell.js';
import { Card } from '../../shared/ui/Card.js';
import { PostPayCta } from '../post-pay/PostPayCta.js';
import { PostPurchaseFavoritePrompt } from '../checkout/PostPurchaseFavoritePrompt.js';
import { usePostKioskProductJourney } from './hooks/usePostKioskProductJourney.js';
import { usePublishHierarchicalBackFlow } from '../../shared/context/HierarchicalBackFlowContext.js';
import { useTenantCode } from '../../shared/tenant/TenantProvider.js';
import { readLastKnownSalesPointSlug } from '../../shared/session/lastKnownSalesPoint.js';

export function PostKioskProductJourney(): JSX.Element {
  const screen = usePostKioskProductJourney();
  const tenantCode = useTenantCode();
  // Success terminal: clear hierarchical step-back hints; fixed shell owns ← → shop.
  usePublishHierarchicalBackFlow(null);

  return (
    <JourneyShell
      title={screen.title}
      subtitle={screen.subtitle}
      context="POST_KIOSK_PRODUCT"
      // Content bar off — shell hierarchical ← exits to shop.
      backTo={null}
    >
      <Card padded>
        <div className="flex flex-col gap-2 text-center">
          <span aria-hidden="true" className="text-3xl text-[var(--color-success)]">
            ✓
          </span>
          <h2 className="text-lg font-semibold">{screen.doneLabel}</h2>
          <p className="text-sm text-[var(--color-on-surface-muted)]">{screen.description}</p>
        </div>
      </Card>

      {screen.salesPointId !== null ? (
        <PostPurchaseFavoritePrompt
          tenantCode={tenantCode}
          salesPointId={screen.salesPointId}
          salesPointSlug={readLastKnownSalesPointSlug(tenantCode) ?? undefined}
          enabled={screen.favoritePromptEnabled}
        />
      ) : null}

      {screen.paymentId.length > 0 ? (
        <PostPayCta paymentId={screen.paymentId} onContinue={screen.onPostPayContinue} />
      ) : null}
    </JourneyShell>
  );
}
